import React, { FC } from 'react';

import {
  SelectButtonProps,
  SelectDynamicButtonProps,
} from './SelectButton.types';
import { Label } from '../TypographyNew';
import {
  CheckCircle,
  SelectButtonContainer,
  SelectButtonDynamicLabel,
} from './SelectButton.styles';
import { TrevorIcon } from '../TrevorIcon';

export const SelectButton: FC<SelectButtonProps> = ({
  iconName,
  value,
  isSelected = false,
  children,
  noCheck,
  ...props
}) => {
  return (
    <SelectButtonContainer isSelected={isSelected} {...props}>
      {iconName && (
        <span>
          <TrevorIcon name={iconName} size="md" />
        </span>
      )}
      <Label variant={1}>{children}</Label>
      {!noCheck && <CheckCircle isSelected={isSelected} />}
    </SelectButtonContainer>
  );
};

export const SelectDynamicButton: FC<SelectDynamicButtonProps> = ({
  iconName,
  label,
  value,
  placeholder,
  isSelected = false,
  onSelect,
  onBlur,
  children,
  ...props
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [isEditMode, setIsEditMode] = React.useState(false);

  React.useEffect(() => {
    if (!isSelected) {
      setIsEditMode(false);
    }
  }, [isSelected]);

  const handleClick = () => {
    setIsEditMode(true);
  };

  const handleBlur = () => {
    setIsEditMode(false);
    onBlur?.();
  };

  const displayLabel = isEditMode || !isSelected;

  const handleChange = () => {
    onSelect(inputRef.current?.value ?? null);
  };

  return (
    <SelectButtonContainer
      isSelected={isSelected}
      onClick={handleClick}
      {...props}
    >
      {iconName && (
        <span>
          <TrevorIcon name={iconName} size="md" />
        </span>
      )}
      {isEditMode && (
        <input
          autoFocus
          ref={inputRef}
          value={value}
          placeholder={placeholder}
          onBlur={handleBlur}
          onChange={handleChange}
        />
      )}
      <SelectButtonDynamicLabel isTop={isEditMode} withIcon={Boolean(iconName)}>
        {displayLabel ? label : value}
      </SelectButtonDynamicLabel>
      <CheckCircle isSelected={isSelected} />
    </SelectButtonContainer>
  );
};
